export default __webpack_public_path__ + "static/media/vivek-bindra.073decaf.svg";